// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__2kg9Q","additionalInfo":"AgreementModal_additionalInfo__1apWi"};